const C = {
  name: "TurnRight",
  dimensions: { width: 18, height: 21 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7071 0.292893C10.3166 -0.0976311 9.68342 -0.0976311 9.29289 0.292893C8.90237 0.683417 8.90237 1.31658 9.29289 1.70711L10.5858 3H9C4.02944 3 0 7.02944 0 12C0 16.9706 4.02944 21 9 21C13.9706 21 18 16.9706 18 12C18 11.4477 17.5523 11 17 11C16.4477 11 16 11.4477 16 12C16 15.866 12.866 19 9 19C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5H10.5858L9.29289 6.29289C8.90237 6.68342 8.90237 7.31658 9.29289 7.70711C9.68342 8.09763 10.3166 8.09763 10.7071 7.70711L13.7071 4.70711C14.0976 4.31658 14.0976 3.68342 13.7071 3.29289L10.7071 0.292893Z" fill="currentColor"/>  `
};
export {
  C as TurnRight
};
